import { AssigneeSelector as BaseAssigneeSelector } from '@tabeo/scarf'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useAdminUsers } from 'resources/AdminUsers'

export const filterFields = ['email', 'firstName', 'lastName']
export const filter = (fields, query) => item => {
  const normalizedQuery = query.toLowerCase()
  return fields.find(field => {
    const normalizedItemFieldValue = item?.[field]?.toLowerCase() || ''
    return normalizedItemFieldValue.includes(normalizedQuery)
  })
}

function AssigneeSelector({ hasNotAssigned, ...rest }) {
  const { data } = useAdminUsers()
  const fetchAdminUsers = useCallback(
    async query => {
      const items = data
      const result = items.filter(filter(filterFields, query)).map(i => ({
        value: i.id,
        data: {
          ...i,
          name: `${i.firstName} ${i.lastName}`,
        },
      }))
      return [
        ...result,
        hasNotAssigned && { value: null, data: { label: 'Not assigned' } },
      ].filter(Boolean)
    },
    [data, hasNotAssigned]
  )

  return <BaseAssigneeSelector loadOptions={fetchAdminUsers} {...rest} />
}

AssigneeSelector.propTypes = {
  hasNotAssigned: PropTypes.bool,
}

export default AssigneeSelector
